import store from "../state/store";

export default {
    install: function (Vue) {
        // Minden híváskor az AKTUÁLIS getter: a betöltéskor elkapott függvény a belépés előtti állapotot látta, és belépés után,
        // újratöltésig hamisat adott (a lista Létrehozás, szerkesztés és törlés gombja hiányzott, mérve 2026-10-06).
        Vue.config.globalProperties.can = (permission) => store.getters['auth/can'](permission)
        // 1. add global method or property
        /*Vue.myGlobalMethod = function () {
            // some logic ...
        }*/

        // 2. add a global asset
        /*Vue.directive('my-directive', {
            bind (el, binding, vnode, oldVnode) {
                // some logic ...
            }
        })*/

        // 3. inject some component options
        /*Vue.mixin({
            created: function () {
                // some logic ...
            }
            ...
        })*/

        // 4. add an instance method
        /*Vue.prototype.$myMethod = function (methodOptions) {
            // some logic ...
        }*/
    }
}
